<template>
  <div
    v-if="isEnabled('postalCode')"
    class="col">
    <div class="form-group">
      <label>{{ labels.postalCode }}</label>
      <input
        v-model="address.zip"
        :name="`${name}-postalCode`"
        :class="{ 'is-invalid': errors.has(`${name}-postalCode}`) }"
        :data-vv-as="labels.postalCode"
        :disabled = "isDisabled"
        class="form-control"
        type="text"
        data-test="postal-code"
        @input="input"
        @blur="blur"
      >
      <div
        v-if="errors.has(`${name}-postalCode`)"
        class="invalid-feedback">
        {{ errors.first(`${name}-postalCode`) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    address: {
      type: Object,
      default: Object
    },
    labels: {
      type: Object,
      default: Object
    },
    name: {
      type: String,
      required: true
    },
    optionalForm: {
      type: Boolean,
      default: false
    },
    addressConfig: {
      type: Object,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    input () {
      this.$emit('input')
    },
    blur () {
      this.$emit('blur')
    },
    isEnabled (field) {
      return this.addressConfig[field] && this.addressConfig[field].enabled
    }
  }
}
</script>
